export default __webpack_public_path__ + "static/media/pact.e91afe92.jpg";